module.exports = __webpack_public_path__ + "static/img/ys_bg.4c5128d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/ys_bg.jpg
// module id = XcD0
// module chunks = 0